/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AllocationRow = {
  __typename?: 'AllocationRow';
  allocation?: Maybe<Scalars['Int']>;
  allocationId: Scalars['ID'];
  canModifyAdjustments: Scalars['Boolean'];
  lastUpdate?: Maybe<Scalars['String']>;
  manualSales?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  ticketCompanyId: Scalars['ID'];
  ticketCompanyName?: Maybe<Scalars['String']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
};

export type ExternalUser = {
  __typename?: 'ExternalUser';
  authProvider: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  providerId: Scalars['String'];
};

export type Health = {
  __typename?: 'Health';
  microserviceResults?: Maybe<Array<MicroserviceHealth>>;
  status: Scalars['String'];
};

export type MicroserviceHealth = {
  __typename?: 'MicroserviceHealth';
  isSuccess: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  externalUser: ExternalUser;
  getTicketingTours: Array<Maybe<Tour>>;
  health: Health;
  tourTicketSales: TourTicketSales;
};


export type QueryExternalUserArgs = {
  providerId: Scalars['String'];
};


export type QueryGetTicketingToursArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryTourTicketSalesArgs = {
  tourId: Scalars['ID'];
};

export type ShowTicketSales = {
  __typename?: 'ShowTicketSales';
  allocations: Array<AllocationRow>;
  showDate?: Maybe<Scalars['String']>;
  showId: Scalars['ID'];
};

export type Tour = {
  __typename?: 'Tour';
  headliner?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TourDetails = {
  __typename?: 'TourDetails';
  buyer?: Maybe<Scalars['String']>;
  coHeadliners: Array<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  headliner?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isMultiLegTour: Scalars['Boolean'];
  name: Scalars['String'];
  operator?: Maybe<Scalars['String']>;
};

export type TourTicketSales = {
  __typename?: 'TourTicketSales';
  tour: TourDetails;
  venues: Array<VenueTicketSales>;
};

export type VenueTicketSales = {
  __typename?: 'VenueTicketSales';
  shows: Array<ShowTicketSales>;
  venueId: Scalars['ID'];
  venueName: Scalars['String'];
};

export type ExternalUserQueryVariables = Exact<{
  providerId: Scalars['String'];
}>;


export type ExternalUserQuery = { __typename?: 'Query', externalUser: { __typename?: 'ExternalUser', id: string, name: string, email: string, providerId: string, authProvider: string, phoneNumber?: string | null, isActive: boolean } };

export type TourTicketSalesQueryVariables = Exact<{
  tourId: Scalars['ID'];
}>;


export type TourTicketSalesQuery = { __typename?: 'Query', tourTicketSales: { __typename?: 'TourTicketSales', tour: { __typename?: 'TourDetails', id: string, name: string, headliner?: string | null, coHeadliners: Array<string>, company?: string | null, isMultiLegTour: boolean, buyer?: string | null, operator?: string | null }, venues: Array<{ __typename?: 'VenueTicketSales', venueId: string, venueName: string, shows: Array<{ __typename?: 'ShowTicketSales', showId: string, showDate?: string | null, allocations: Array<{ __typename?: 'AllocationRow', allocationId: string, ticketCompanyName?: string | null, ticketType?: string | null, ticketName?: string | null, allocation?: number | null, price?: number | null, lastUpdate?: string | null, manualSales?: number | null, canModifyAdjustments: boolean }> }> }> } };


export const ExternalUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"authProvider"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<ExternalUserQuery, ExternalUserQueryVariables>;
export const TourTicketSalesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TourTicketSales"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tourId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tourTicketSales"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tourId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tourId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tour"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"headliner"}},{"kind":"Field","name":{"kind":"Name","value":"coHeadliners"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"isMultiLegTour"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}}]}},{"kind":"Field","name":{"kind":"Name","value":"venues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"venueId"}},{"kind":"Field","name":{"kind":"Name","value":"venueName"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showId"}},{"kind":"Field","name":{"kind":"Name","value":"showDate"}},{"kind":"Field","name":{"kind":"Name","value":"allocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocationId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"ticketType"}},{"kind":"Field","name":{"kind":"Name","value":"ticketName"}},{"kind":"Field","name":{"kind":"Name","value":"allocation"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"manualSales"}},{"kind":"Field","name":{"kind":"Name","value":"canModifyAdjustments"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TourTicketSalesQuery, TourTicketSalesQueryVariables>;